var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.51971,2H3.47583A1.4596,1.4596,0,0,0,2,3.44128V20.557A1.46054,1.46054,0,0,0,3.47583,22H20.51971A1.46344,1.46344,0,0,0,22,20.557V3.44128A1.46251,1.46251,0,0,0,20.51971,2ZM7.93176,19.04279H4.96527V9.49811H7.93176ZM6.44916,8.1933A1.71988,1.71988,0,1,1,8.168,6.4729,1.7203,1.7203,0,0,1,6.44916,8.1933Zm12.593,10.84949H16.078V14.401c0-1.10675-.02057-2.5307-1.5415-2.5307-1.54364,0-1.78058,1.20569-1.78058,2.45056v4.72193H9.79218V9.49811h2.84533v1.304h.03961A3.117,3.117,0,0,1,15.48383,9.2608c3.00384,0,3.55835,1.97675,3.55835,4.54645Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.502a6c8ffbb42e113a8afce822504130.svg";
export { ForwardRef as ReactComponent };